import IMAGE_COMMON from './imagesCommon';

const IMAGE = Object.freeze({
    OFFICIAL_LOGO: {
        height: '100%',
        width: 'auto',
        common: true,
        name: 'official_logo'
    },
    ...IMAGE_COMMON,
});

export default IMAGE;
